// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"image_shadow__3QMxw","button":"image_button__C3uOg"};